import { FC, useRef } from 'react';

import { changeAccount } from 'utils/clickme';

import { BottomSheet, Drop, Link, Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';
import { ChevronDownOutlinedSize16, ChevronUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import { AccountSwitcherOption } from 'components/Header/HeaderUserDrop/AccountSwitcher/AccountSwitcherOption/AccountSwitcherOption';

import { useSelector } from 'store/utils';

export const AccountSelect: FC = () => {
    const currentAccountId = useSelector(({ user }) => user.user?.currentAccount.id);
    const accounts = useSelector(({ user }) => user.user?.accounts);

    const [isDropVisible, setIsDropVisibleOn, setIsDropVisibleOff] = useOnOffState(false);

    const dashboardRoute = useDashboardRoute();
    const dropActivatorRef = useRef(null);

    const currentAccountTitle = accounts?.find((account) => account.id === currentAccountId)?.title;

    const content = (
        <VSpacingContainer default={8}>
            {accounts &&
                Object.values(accounts).map(({ id, title }) => (
                    <AccountSwitcherOption
                        key={id}
                        accountId={id}
                        accountTitle={title}
                        onClick={() => {
                            changeAccount(String(id), dashboardRoute);
                            setIsDropVisibleOff();
                        }}
                        checked={id === currentAccountId}
                    />
                ))}
        </VSpacingContainer>
    );

    return (
        <>
            {currentAccountTitle && (
                <>
                    <VSpacing default={16} />
                    <Link
                        Element="button"
                        mode="secondary"
                        style="neutral"
                        iconRight={isDropVisible ? <ChevronUpOutlinedSize16 /> : <ChevronDownOutlinedSize16 />}
                        ref={dropActivatorRef}
                        onClick={isDropVisible ? setIsDropVisibleOff : setIsDropVisibleOn}
                        data-qa="account-switcher"
                    >
                        <Text Element="span" typography="label-3-regular">
                            {currentAccountTitle}
                        </Text>
                    </Link>
                    <Drop
                        activatorRef={dropActivatorRef}
                        placement="bottom-center"
                        width={432}
                        padding={12}
                        visible={isDropVisible}
                        onClose={setIsDropVisibleOff}
                    >
                        {content}
                    </Drop>
                    <BottomSheet
                        height="content"
                        visible={isDropVisible}
                        onClose={setIsDropVisibleOff}
                        data-qa="header-user-drop"
                    >
                        {content}
                        <VSpacing default={12} />
                    </BottomSheet>
                </>
            )}
        </>
    );
};
